// extracted by mini-css-extract-plugin
module.exports = {"htmlRem":"App_htmlRem__3kSVn"};